Vue.component('ack-slider', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-slider',
	mounted() {
		this.setSlider();

		setTimeout(() => {
			this.carousel = new bootstrap.Carousel('#' + this.carouselId);
		}, 1000);
	},
	props: {
		slides: {
			type: Array,
		},
		carouselId: {
			type: String,
		},
		showButtonsPrevNext: {
			type: Boolean,
			default: false,
		},
		isMobile: {
			type: Boolean,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
	},
	data() {
		return {
			slideList: null,
			carousel: null,
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),

		setSlider() {
			//&& this.slides != []
			if (this.slides != null) {
				this.slideList = this.slides
					.filter((m) => {
						if (this.isMobile) {
							return m.platform == 'mobile';
						} else {
							return m.platform == 'desktop';
						}
					})
					.sort((a, b) => a.order - b.order);
			} else {
				this.slideList = [
					{
						img: window.ackShopifyFileUrl("ALPHA_AI_CAD_Functions_Slider_Slider_1980.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("ALPHA_AI_CAD_Functions_Slider_Slider_480.jpg"),
						alt: 'alpha-ai',
						title: 'ALPHA AI',
						startDate: '',
						endDate: '',
						active: true,
						href: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
					},
					{
						img: window.ackShopifyFileUrl("FLOW_Slider_1980.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("FLOW_Slider_480.jpg"),
						alt: 'flow-resins',
						title: 'FLOW Resins',
						startDate: '',
						endDate: '',
						active: false,
						href: '/pages/flow-resins-for-dental-3d-printed-applications',
					},
					{
						img: window.ackShopifyFileUrl("NFinity_Slider_1980.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("NFinity_Slider_480.jpg"),
						alt: 'curie-plus-nfinity',
						title: 'CURIE Plus & NFinity',
						startDate: '',
						endDate: '',
						active: false,
						href: '/products/curie-plus-nitrogen-compatible-uv-oven',
					},
					{
						img: window.ackShopifyFileUrl("SOL_Resin_Heater_Slider_1980.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("SOL_Resin_Heater_Slider_480.jpg"),
						alt: 'sol-heater',
						title: 'SOL Heater',
						startDate: '',
						endDate: '',
						active: false,
						href: '/products/sol#image-element-section',
					},
					{
						img: window.ackShopifyFileUrl("3DPS_Plus_1440_Slider.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("3DPS_Plus_390_Slider.jpg"),
						alt: '3dps-plus',
						title: '3DPS Plus',
						startDate: '',
						endDate: '',
						active: false,
						href: '/products/sol-plus',
					},
					{
						img: window.ackShopifyFileUrl("Ortho-Model_1440_Slider.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("Ortho-Model_390_Slider.jpg"),
						alt: 'ortho-model',
						title: 'CURO Ortho Model',
						startDate: '',
						endDate: '',
						active: false,
						href: '/pages/curo-resins',
					},
					{
						img: window.ackShopifyFileUrl("CURO_Element_Model_Slider_Slider_1980_020478f1-e6f6-4d95-826e-893ea4f75ce3.jpg"),
						imgMobile:
							window.ackShopifyFileUrl("CURO_Element_Model_Slider_Slider_480_4298856f-8fed-47e0-b7a5-a3a0f966882b.jpg"),
						alt: 'element-model',
						title: 'CURO Element Model',
						startDate: '',
						endDate: '',
						active: false,
						href: '/pages/curo-resins',
					},
				];
			}
		},
	},
	beforeDestroy() {},
	watch: {
		slides: {
			handler() {
				this.setSlider();
			},
			deep: false,
		},
		isMobile: {
			handler() {
				this.setSlider();
			},
			deep: false,
		},
	},
});
